import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class ProductBundleTemplatesService {
  getProductBundleTemplates({ cancelToken = null }) {
    return ApiService.get(`${Config.api.slipExtractor.url}api/v1/product-bundle-templates`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }
}

export const productBundleTemplatesService = new ProductBundleTemplatesService();
